import type { CoreState } from '../core.reducer';

export function getRouterInitialUrl(state: CoreState) {
  return state.router.initialUrl;
}

export function getRouterInitialUrlActivated(state: CoreState) {
  return state.router.initialUrlActivated;
}
